import { bindActionCreators } from 'redux';
import { connect } from '../../../../react-redux';
import { isOneQuestionAtATime, getBacktrackingIsAllowed, getActiveQuizSessionId } from '../../../../selectors/quizSessions';
import { toggleSidebar } from '../../../../actions/sidebar';
import { screenreaderNotification as screenreaderNotificationAction } from '../../../../actions/alerts';
import { HeaderMenuButton as HeaderMenuButtonPresenter } from './presenter';
export var mapStateToProps = function mapStateToProps(state, props) {
  var hideOnTake = isOneQuestionAtATime(state) && !getBacktrackingIsAllowed(state);
  var quizSessionNotLoaded = getActiveQuizSessionId(state) === '0';
  var hidden = !!props.onTake && (hideOnTake || quizSessionNotLoaded);
  var sidebarOpen = props.sidebarOpen || state.getIn(['sidebar', 'isOpen']);
  return {
    hidden: hidden,
    sidebarOpen: sidebarOpen
  };
};
export function mapDispatchToProps(dispatch, props) {
  return {
    sidebarMenuClick: props.sidebarMenuClick || bindActionCreators(toggleSidebar, dispatch),
    screenreaderNotification: bindActionCreators(screenreaderNotificationAction, dispatch)
  };
}
export var HeaderMenuButton = connect(mapStateToProps, mapDispatchToProps)(HeaderMenuButtonPresenter);
export default HeaderMenuButton;